module.exports = __webpack_public_path__ + "img/1.3e9b9e95.png";